import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M4 4H2V2h2v2Zm3-2v2h2V2H7Zm5 0v2h2V2h-2ZM2 14h2v-2H2v2Zm0-5h2V7H2v2Zm5-2h2v2H7V7Zm0 5h2v2H7v-2Zm5-5h2v2h-2V7Zm0 5h2v2h-2v-2Z';
const draw24px = 'M3 3h4v4H3V3Zm0 7h4v4H3v-4Zm0 7h4v4H3v-4Zm7-14h4v4h-4V3Zm0 7h4v4h-4v-4Zm0 7h4v4h-4v-4Zm7-14h4v4h-4V3Zm0 7h4v4h-4v-4Zm0 7h4v4h-4v-4Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ViewAllFilledIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'viewAllFilled'));
ViewAllFilledIcon.displayName = 'ViewAllFilledIcon';
ViewAllFilledIcon.propTypes = Icon.propTypes;
ViewAllFilledIcon.renderIcon = props => /*#__PURE__*/React.createElement(ViewAllFilledIcon, props);
export default ViewAllFilledIcon;
//# sourceMappingURL=ViewAllFilledIcon.js.map